document.addEventListener('DOMContentLoaded', () => {
const quiz = window.LPM_MAROO_QUIZ_ADULT_DATA;
  if (!quiz) {
    console.warn('LPM Quiz adulte : données adulte introuvables.');
    return;
  }

  let currentQuestion = 0;
  let answers = [];
  let shownInterludes = {
    first: false,
    second: false
  };

  const root = document.getElementById('lpm-maroo-quiz-adult');

if (!root) {
  console.warn('LPM Quiz adulte : section introuvable.');
  return;
}

const introImage = root.querySelector('#lpm-adult-intro-image');

  const screens = root.querySelectorAll('.lpm-maroo-screen');
  const questionContainer = root.querySelector('#lpm-adult-question-container');
  const interludeContent = root.querySelector('#lpm-interlude-content');
  const analysisContent = root.querySelector('#lpm-analysis-content');
  const resultHero = root.querySelector('#lpm-result-hero');
  const progressFill = root.querySelector('#lpm-progress-fill');

  const params = new URLSearchParams(window.location.search);
  const debugScreen = params.get('debug');
  const debugForce = params.get('force');

  function showScreen(name) {
    screens.forEach(screen => screen.classList.remove('is-active'));

    const target = root.querySelector(`[data-screen="${name}"]`);

    if (target) {
      target.classList.add('is-active');
    } else {
      console.warn(`LPM Quiz adulte : écran introuvable → ${name}`);
    }
  }

  function resetQuiz() {
    currentQuestion = 0;
    answers = [];
    shownInterludes = {
      first: false,
      second: false
    };
  }

  function getScoreTemplate() {
    if (quiz && quiz.archetypes) {
      return Object.keys(quiz.archetypes).reduce((scores, id) => {
        scores[id] = 0;
        return scores;
      }, {});
    }

    return {};
  }

  function calculateScores() {
    const scores = getScoreTemplate();

    if (!quiz || !quiz.questions) return scores;

    answers.forEach((answerIndex, questionIndex) => {
      const question = quiz.questions[questionIndex];

      if (!question || answerIndex === undefined || answerIndex === null) return;

      const answer = question.answers[answerIndex];

      if (!answer || !answer.archetype) return;

      const weight = question.weight || 1;
      scores[answer.archetype] += weight;
    });

    return scores;
  }

  function getSortedScores() {
    const scores = calculateScores();

    return Object.entries(scores)
      .map(([id, score]) => ({ id, score }))
      .sort((a, b) => b.score - a.score);
  }

  function getDominantArchetype() {
    return getSortedScores()[0]?.id || null;
  }

  function getSecondaryArchetypes(winnerId) {
    const sorted = getSortedScores();
    const winnerScore = sorted.find(item => item.id === winnerId)?.score || 0;

    return sorted
      .filter(item => item.id !== winnerId)
      .filter(item => winnerScore - item.score <= 2)
      .slice(0, 2)
      .map(item => item.id);
  }

  function getProgressPercent() {
    if (!quiz || !quiz.questions || !quiz.questions.length) return 0;
    return Math.round((currentQuestion / quiz.questions.length) * 100);
  }

  function updateProgress() {
    if (!progressFill || !quiz) return;
    progressFill.style.width = `${getProgressPercent()}%`;
  }

  function bindInterludeContinue() {
    if (!interludeContent) return;

    interludeContent
      .querySelectorAll('[data-action="continue"]')
      .forEach(button => {
        button.addEventListener('click', () => {
          renderQuestion();
        });
      });
  }

  function renderQuestion() {
    if (!quiz || !quiz.questions) {
      console.warn('LPM Quiz adulte : aucune donnée de quiz disponible.');
      return;
    }

    const question = quiz.questions[currentQuestion];

    if (!question) {
      renderAnalysis();
      return;
    }

    updateProgress();

    const questionNumber = currentQuestion + 1;
    const visual = quiz.questionVisuals?.[questionNumber];

    if (!visual?.desktop) {
      console.warn(`LPM Quiz adulte : visuel question introuvable → Q${questionNumber}`);
      return;
    }

    questionContainer.innerHTML = `
      <div class="lpm-maroo-question-visual" data-question-visual="adult-${questionNumber}">
        <picture>
          ${visual.mobile ? `<source media="(max-width: 768px)" srcset="${visual.mobile}">` : ''}

          <img
            src="${visual.desktop}"
            alt="Question du quiz Les Petits Maroo"
            loading="eager"
            class="lpm-maroo-question-image"
          >
        </picture>

        <button type="button" class="lpm-maroo-question-hotspot lpm-maroo-adult-q${questionNumber}-a" data-answer-index="0" aria-label="Réponse A"></button>
        <button type="button" class="lpm-maroo-question-hotspot lpm-maroo-adult-q${questionNumber}-b" data-answer-index="1" aria-label="Réponse B"></button>
        <button type="button" class="lpm-maroo-question-hotspot lpm-maroo-adult-q${questionNumber}-c" data-answer-index="2" aria-label="Réponse C"></button>
        <button type="button" class="lpm-maroo-question-hotspot lpm-maroo-adult-q${questionNumber}-d" data-answer-index="3" aria-label="Réponse D"></button>
      </div>
    `;

    questionContainer
      .querySelectorAll('.lpm-maroo-question-hotspot')
      .forEach(button => {
        button.addEventListener('click', () => {
          selectAnswer(Number(button.dataset.answerIndex));
        });
      });

    showScreen('question');
  }

  function selectAnswer(answerIndex) {
    answers[currentQuestion] = answerIndex;
    currentQuestion += 1;

    if (currentQuestion === 5 && !shownInterludes.first) {
      shownInterludes.first = true;
      renderInterlude('first');
      return;
    }

    if (currentQuestion === 11 && !shownInterludes.second) {
      shownInterludes.second = true;
      renderInterlude('second');
      return;
    }

    renderQuestion();
  }

 function renderInterlude(type) {

  const dominant = getDominantArchetype() || 'defricheuse';
  const interludeNumber = type === 'second' ? '2' : '1';

  const visual =
    quiz.interludeVisuals?.[`interlude-${interludeNumber}-${dominant}`];

  if (!visual?.desktop) {
    console.warn(`Interlude introuvable : interlude-${interludeNumber}-${dominant}`);
    renderQuestion();
    return;
  }

  interludeContent.innerHTML = `
    <div class="lpm-maroo-interlude-visual">

      <picture>
        ${visual.mobile ? `
          <source media="(max-width:768px)" srcset="${visual.mobile}">
        ` : ""}

        <img
          src="${visual.desktop}"
          class="lpm-maroo-interlude-image"
          loading="eager"
          alt="Interlude du quiz Les Petits Maroo">
      </picture>

      <button
        type="button"
        class="lpm-maroo-interlude-hotspot lpm-maroo-i${interludeNumber}-${dominant}"
        data-action="continue"
        aria-label="Poursuivre l'enquête">
      </button>

    </div>
  `;

  bindInterludeContinue();
  showScreen('interlude');
}

function renderForcedInterlude(interludeNumber, archetype) {

  const visual =
    quiz.interludeVisuals?.[`interlude-${interludeNumber}-${archetype}`];

  if (!visual?.desktop) {
    console.warn(`Interlude debug introuvable : interlude-${interludeNumber}-${archetype}`);
    
    showScreen('intro-adult');
    return;
  }

  interludeContent.innerHTML = `
    <div class="lpm-maroo-interlude-visual">

      <picture>
        ${visual.mobile ? `
          <source media="(max-width:768px)" srcset="${visual.mobile}">
        ` : ""}

        <img
          src="${visual.desktop}"
          class="lpm-maroo-interlude-image"
          loading="eager"
          alt="Interlude du quiz Les Petits Maroo">
      </picture>

      <button
        type="button"
        class="lpm-maroo-interlude-hotspot lpm-maroo-i${interludeNumber}-${archetype}"
        data-action="continue"
        aria-label="Poursuivre l'enquête">
      </button>

    </div>
  `;

  bindInterludeContinue();
  showScreen('interlude');
}

function renderAnalysis() {

  if (!analysisContent) return;

  const visual = quiz.interludeVisuals?.analysis;

  if (!visual?.desktop) {
    console.warn('Analyse finale introuvable.');
    renderResult();
    return;
  }

  const isMobile = window.matchMedia('(max-width:768px)').matches;
  const image = isMobile && visual.mobile
    ? visual.mobile
    : visual.desktop;

  analysisContent.innerHTML = `
    <div class="lpm-maroo-interlude-visual">

      <picture>
        <img
          src="${image}"
          class="lpm-maroo-interlude-image"
          alt="Analyse finale du quiz Les Petits Maroo"
          loading="eager">
      </picture>

      <button
        type="button"
        class="lpm-maroo-interlude-hotspot lpm-maroo-analysis-hotspot"
        data-action="open-result"
        aria-label="Ouvrir mon dossier">
      </button>

    </div>
  `;

  analysisContent
    .querySelector('[data-action="open-result"]')
    .addEventListener('click', renderResult);

  showScreen('analysis');
}
  

  const RESULT_PRODUCT_THEMES = {
    defricheuse: { label: 'Défricheuse', bg: '#eef3eb', accent: '#507d3c' },
    devoreuse: { label: 'Dévoreuse', bg: '#edd5f7', accent: '#7813a3' },
    collectionneuse: { label: 'Collectionneuse', bg: '#f4d8ec', accent: '#d42da7' },
    irrecuperable: { label: 'Irrécupérable', bg: '#fce5e8', accent: '#ed1b65' },
    heritiere: { label: 'Héritière', bg: '#f0d3d9', accent: '#ac1432' }
  };

  function getResultProducts(archetypeId) {
    const source = window.LPM_RESULT_PRODUCTS || {};
    const products = source[archetypeId] || [];

    if (products.length) return products.slice(0, 6);

    return Array.from({ length: 6 }).map((_, index) => ({
      title: `Pièce ${String(index + 1).padStart(3, '0')}`,
      price: '',
      image: '',
      url: '#',
      variantId: null,
      reason: 'Objet sélectionné par le Bureau des Affaires Maroo pour compléter ton dossier.'
    }));
  }

  function getResultHeroTemplate(archetypeId) {

  const hero = quiz.resultHeroes?.[archetypeId];

  if (!hero?.desktop) return null;

  const isMobile = window.matchMedia('(max-width:768px)').matches;
  const image = isMobile ? hero.mobile : hero.desktop;

  return {
    innerHTML: `
      <picture>
        <img
          src="${image}"
          class="lpm-result-hero-image"
          alt="Résultat du quiz Les Petits Maroo"
          loading="eager">
      </picture>
    `
  };

}

  function getResultDossierTemplate(archetypeId) {

  const dossier = quiz.resultDossiers?.[archetypeId];

  if (!dossier?.image) return null;

  return {
    innerHTML: `
      <img
        src="${dossier.image}"
        class="lpm-result-dossier-image"
        alt="Dossier confidentiel"
        loading="eager">
    `
  };

}

  function getResultMainBoardUrl() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    return isMobile
      ? 'https://cdn.shopify.com/s/files/1/0931/3003/1484/files/fond-cartes-resultats-influence-principale-quiz-maroo-mobile.png?v=1781688329'
      : 'https://cdn.shopify.com/s/files/1/0931/3003/1484/files/fond-cartes-resultats-influence-principale-quiz-maroo-1.webp?v=1781616046';
  }

  function getResultSecondaryBoardPicture() {
    return `
      <picture class="lpm-result-secondary-bg">
        <source
          media="(max-width:768px)"
          srcset="https://cdn.shopify.com/s/files/1/0931/3003/1484/files/fond-cartes-influences-secondaires-mobile_3373a032-b7db-4648-96b3-91633a7fa894.png?v=1781687584"
        >
        <img
          src="https://cdn.shopify.com/s/files/1/0931/3003/1484/files/fond-cartes-influences-secondaires-desktop.png?v=1781685968"
          alt="Pièces à conviction"
        >
      </picture>
    `;
  }

  function getResultBannerImage(archetypeId, level) {
  return quiz.resultBanners?.[archetypeId]?.[level] || '';
}

  function ensureProductModal() {
    let modal = document.getElementById('lpm-result-product-modal');

    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = 'lpm-result-product-modal';
    modal.className = 'lpm-result-product-modal';
    modal.innerHTML = `
      <div class="lpm-result-product-modal-backdrop" data-action="close-product-modal"></div>

      <div class="lpm-result-product-modal-card">
        <button type="button" class="lpm-result-product-modal-close" data-action="close-product-modal">×</button>

        <div class="lpm-result-product-modal-image"></div>

        <div class="lpm-result-product-modal-copy">
          <p class="lpm-result-product-modal-kicker"></p>
          <h3></h3>
          <p class="lpm-result-product-modal-reason"></p>
          <p class="lpm-result-product-modal-price"></p>

          <button type="button" class="lpm-result-product-modal-cart">
            Ajouter au panier
          </button>

          <a class="lpm-result-product-modal-link" href="#">
            Voir la fiche complète
          </a>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    modal.querySelectorAll('[data-action="close-product-modal"]').forEach(button => {
      button.addEventListener('click', closeProductModal);
    });

    return modal;
  }

  function openProductModal(product, index, archetypeId) {
    const modal = ensureProductModal();
    const theme = RESULT_PRODUCT_THEMES[archetypeId] || RESULT_PRODUCT_THEMES.defricheuse;

    modal.style.setProperty('--lpm-product-modal-bg', theme.bg);
    modal.style.setProperty('--lpm-product-modal-accent', theme.accent);

    modal.querySelector('.lpm-result-product-modal-kicker').textContent =
      `Pièce à conviction n°${String(index + 1).padStart(3, '0')}`;

    modal.querySelector('h3').textContent = product.title || '';
    modal.querySelector('.lpm-result-product-modal-reason').textContent = product.reason || '';
    modal.querySelector('.lpm-result-product-modal-price').textContent = product.price || '';

    const imageBox = modal.querySelector('.lpm-result-product-modal-image');
    imageBox.innerHTML = product.image
      ? `<img src="${product.image}" alt="${product.title || ''}">`
      : '';

    const link = modal.querySelector('.lpm-result-product-modal-link');
    link.href = product.url || '#';

    const cartButton = modal.querySelector('.lpm-result-product-modal-cart');

    cartButton.onclick = () => {
      if (!product.variantId) return;
      addResultProductToCart(product.variantId);
    };

    cartButton.disabled = !product.variantId;
    cartButton.textContent = product.variantId ? 'Ajouter au panier' : 'Produit à connecter';

    modal.classList.remove('lpm-result-product-modal--child');
    modal.classList.add('lpm-result-product-modal--adult');
    modal.classList.add('is-open');
  }

  function closeProductModal() {
    const modal = document.getElementById('lpm-result-product-modal');
    if (modal) modal.classList.remove('is-open');
  }

  function addResultProductToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(response => response.json())
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(error => {
        console.warn('Ajout panier impossible :', error);
      });
  }

  function getFlatImageFromPicture(html) {
    const temp = document.createElement('div');
    temp.innerHTML = html || '';

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const source = isMobile ? temp.querySelector('source') : null;
    const img = temp.querySelector('img');

    return source?.getAttribute('srcset') || img?.getAttribute('src') || '';
  }

  const RESULT_EMAIL_COPY = {
    defricheuse: {
      title: 'Défricheuse de Sentiers Battus',
      intro: 'Ton dossier révèle une énergie libre, curieuse, difficile à faire rentrer dans une case trop bien dessinée.'
    },
    devoreuse: {
      title: 'Dévoreuse de Mondes',
      intro: 'Ton dossier révèle une âme qui plonge dans les histoires, les détails et les mondes parallèles avec une intensité très suspecte.'
    },
    collectionneuse: {
      title: 'Collectionneuse d’Étrangetés Heureuses',
      intro: 'Ton dossier révèle un goût très net pour les objets inattendus, les trouvailles absurdes et les petites bizarreries qui rendent la vie plus drôle.'
    },
    irrecuperable: {
      title: 'Irrécupérable du Plaisir',
      intro: 'Ton dossier révèle une capacité rare à repérer les joies simples, les gourmandises, les pauses douces et les plaisirs qui sauvent une journée.'
    },
    heritiere: {
      title: 'Héritière du Monde Sauvage',
      intro: 'Ton dossier révèle un lien profond avec les animaux, les présences discrètes et tout ce qui garde encore une part de vivant indompté.'
    }
  };

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  function setResultEmailMessage(messageBox, text, type) {
    if (!messageBox) return;

    messageBox.textContent = text || '';
    messageBox.classList.remove('is-visible', 'is-error', 'is-success');

    if (!text) return;

    messageBox.classList.add('is-visible');

    if (type === 'error') {
      messageBox.classList.add('is-error');
    }

    if (type === 'success') {
      messageBox.classList.add('is-success');
    }
  }

  function buildResultEmailPayload({ email, winnerId, secondaries }) {
    const secondaryOneId = secondaries?.[0] || '';
    const secondaryTwoId = secondaries?.[1] || '';

    const winnerCopy = RESULT_EMAIL_COPY[winnerId] || {};
    const secondaryOneCopy = RESULT_EMAIL_COPY[secondaryOneId] || {};
    const secondaryTwoCopy = RESULT_EMAIL_COPY[secondaryTwoId] || {};

    return {
      email,
      universe: 'adult',

      result: winnerId,
      resultName: quiz?.archetypes?.[winnerId]?.name || winnerCopy.title || winnerId,
      resultEmailTitle: winnerCopy.title || quiz?.archetypes?.[winnerId]?.name || winnerId,
      resultEmailIntro: winnerCopy.intro || '',

      secondaryOne: secondaryOneId,
      secondaryOneName: quiz?.archetypes?.[secondaryOneId]?.name || secondaryOneCopy.title || secondaryOneId,
      secondaryOneEmailTitle: secondaryOneCopy.title || quiz?.archetypes?.[secondaryOneId]?.name || secondaryOneId,
      secondaryOneEmailIntro: secondaryOneCopy.intro || '',

      secondaryTwo: secondaryTwoId,
      secondaryTwoName: quiz?.archetypes?.[secondaryTwoId]?.name || secondaryTwoCopy.title || secondaryTwoId,
      secondaryTwoEmailTitle: secondaryTwoCopy.title || quiz?.archetypes?.[secondaryTwoId]?.name || secondaryTwoId,
      secondaryTwoEmailIntro: secondaryTwoCopy.intro || '',

      mainProducts: getResultProducts(winnerId).slice(0, 6).map(product => ({
        title: product.title || '',
        price: product.price || '',
        url: product.url || '',
        image: product.image || ''
      })),

      secondaryOneProducts: secondaryOneId
        ? getResultProducts(secondaryOneId).slice(0, 3).map(product => ({
            title: product.title || '',
            price: product.price || '',
            url: product.url || '',
            image: product.image || ''
          }))
        : [],

      secondaryTwoProducts: secondaryTwoId
        ? getResultProducts(secondaryTwoId).slice(0, 3).map(product => ({
            title: product.title || '',
            price: product.price || '',
            url: product.url || '',
            image: product.image || ''
          }))
        : [],

      createdAt: new Date().toISOString()
    };
  }

  function bindResultEmailForm({ emailCard, winnerId, secondaries }) {
    if (!emailCard) return;

    const input = emailCard.querySelector('[data-result-email-input]');
    const button = emailCard.querySelector('[data-action="send-result-email"]');
    const messageBox = emailCard.querySelector('[data-result-email-message]');

    const shopifyForm = root.querySelector('#lpm-result-shopify-email-form') || document.getElementById('lpm-result-shopify-email-form');
    const shopifyEmail = root.querySelector('#lpm-result-shopify-email') || document.getElementById('lpm-result-shopify-email');
    const shopifyTags = root.querySelector('#lpm-result-shopify-tags') || document.getElementById('lpm-result-shopify-tags');

    if (!input || !button) return;

    button.addEventListener('click', () => {
      const email = input.value.trim();

      if (!email) {
        setResultEmailMessage(
          messageBox,
          'Écris ton email pour recevoir ton dossier.',
          'error'
        );
        return;
      }

      if (!isValidEmail(email)) {
        setResultEmailMessage(
          messageBox,
          'Cet email ne semble pas valide.',
          'error'
        );
        return;
      }

      const payload = buildResultEmailPayload({
        email,
        winnerId,
        secondaries
      });

      localStorage.setItem(
        'lpm_maroo_quiz_email_payload',
        JSON.stringify(payload)
      );

      const tags = [
        'quiz-maroo',
        'quiz-adulte',
        `resultat-${winnerId}`,
        secondaries?.[0] ? `influence-forte-${secondaries[0]}` : '',
        secondaries?.[1] ? `influence-moderee-${secondaries[1]}` : ''
      ].filter(Boolean).join(', ');

      if (shopifyForm && shopifyEmail && shopifyTags) {
        shopifyEmail.value = email;
        shopifyTags.value = tags;

        if (typeof shopifyForm.requestSubmit === 'function') {
          shopifyForm.requestSubmit();
          return;
        }

        shopifyForm.submit();
        return;
      }

      setResultEmailMessage(
        messageBox,
        'Impossible de transmettre le dossier pour le moment.',
        'error'
      );
    });
  }

  function getExploreItem(archetypeId) {
    return window.LPM_EXPLORE_DATA?.adult?.[archetypeId] || null;
  }

  function renderResultExplore({ container, winnerId, secondaries }) {
    if (!container) return;

    const rawSecondaries = Array.isArray(secondaries)
      ? secondaries.filter(Boolean).slice(0, 2)
      : [];

    const fallbackSecondaries = Object.keys(quiz?.archetypes || {})
      .filter(id => id !== winnerId)
      .slice(0, 2);

    const ids = [
      winnerId,
      ...(rawSecondaries.length ? rawSecondaries : fallbackSecondaries)
    ].filter(Boolean).slice(0, 3);

    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    const templateItem = getExploreItem(winnerId);
    const templateUrl = templateItem
      ? (isMobile && templateItem.templateMobile ? templateItem.templateMobile : templateItem.templateDesktop)
      : '';

    container.innerHTML = `
      <div class="lpm-result-explore-card lpm-result-explore-card--${winnerId}">

        ${ids.map((id, index) => {
          const item = getExploreItem(id);
          if (!item) return '';

          const collectionImage = item.collectionImage || '';

          return `
            <div class="lpm-result-explore-collection lpm-result-explore-slot-${index + 1}">
              ${collectionImage ? `<img src="${collectionImage}" alt="">` : ''}
            </div>
          `;
        }).join('')}

        ${templateUrl ? `
          <img
            class="lpm-result-explore-template"
            src="${templateUrl}"
            alt="Continuer l’exploration"
          >
        ` : ''}

        ${ids.map((id, index) => {
          const item = getExploreItem(id);
          if (!item) return '';

          return `
            <a
              class="lpm-result-explore-hotspot lpm-result-explore-hotspot-${index + 1}"
              href="${item.url || '#'}"
              aria-label="Continuer l’exploration"
            ></a>
          `;
        }).join('')}

      </div>
    `;
  }

  function renderResult() {
    const winnerId = debugForce || getDominantArchetype() || 'defricheuse';
    const secondaries = getSecondaryArchetypes(winnerId);

    const heroTemplate = getResultHeroTemplate(winnerId);
    const dossierTemplate = getResultDossierTemplate(winnerId);

    const dossierContainer = root.querySelector('#lpm-result-dossier');
    const productsContent = root.querySelector('#lpm-products-content');
    const secondaryContainer = root.querySelector('#lpm-result-secondary');
    const emailCard = root.querySelector('#lpm-result-email-card');
    const exploreContainer = root.querySelector('#lpm-result-explore');

    if (heroTemplate && resultHero) {
      resultHero.innerHTML = heroTemplate.innerHTML;
    }

    if (dossierTemplate && dossierContainer) {
      dossierContainer.innerHTML = dossierTemplate.innerHTML;
    }

    if (productsContent) {
      const resultProducts = getResultProducts(winnerId);
      const mainBoardUrl = getResultMainBoardUrl();

      productsContent.innerHTML = `
        <div class="lpm-result-archive-board lpm-result-archive-board--adult lpm-result-archive-board--${winnerId}">

          <div class="lpm-result-archive-products">
            ${resultProducts.map((product, index) => `
              <div class="lpm-result-archive-product lpm-result-archive-product-${index + 1}">
                ${product.image ? `<img src="${product.image}" alt="${product.title || ''}">` : ''}
              </div>
            `).join('')}
          </div>

          <img
            class="lpm-result-archive-bg"
            src="${mainBoardUrl}"
            alt="Objets retrouvés dans ton dossier"
          >

          ${resultProducts.map((product, index) => `
            <button
              type="button"
              class="lpm-result-archive-hotspot lpm-result-archive-hotspot-${index + 1}"
              data-product-index="${index}"
              aria-label="Consulter ${product.title || 'ce produit'}"
            ></button>
          `).join('')}

        </div>
      `;

      productsContent.onclick = (event) => {
        const card = event.target.closest('.lpm-result-archive-hotspot');
        if (!card) return;

        const index = Number(card.dataset.productIndex);
        openProductModal(resultProducts[index], index, winnerId);
      };
    }

    if (secondaryContainer) {
      const fallbackSecondaries = Object.keys(quiz.archetypes)
  .filter(id => id !== winnerId)
  .filter(id => !secondaries.includes(id));

const displayedSecondaries = [
  ...secondaries.slice(0, 2),
  ...fallbackSecondaries
].slice(0, 2);

      secondaryContainer.innerHTML = displayedSecondaries.map((id, index) => {
        const item = quiz.archetypes[id];
const influenceProducts = getResultProducts(id).slice(0, 3);

const bannerLevel = index === 0 ? 'high' : 'moderate';
const bannerImage = getResultBannerImage(id, bannerLevel);

        return `
          <article class="lpm-result-influence-card lpm-result-influence-card--${id}">

            <div class="lpm-result-influence-banner">
              ${bannerImage ? `<img src="${bannerImage}" alt="${item.name}">` : ''}
            </div>

            <div class="lpm-result-secondary-board">
              <img
                class="lpm-result-secondary-bg"
                src="${getFlatImageFromPicture(getResultSecondaryBoardPicture())}"
                alt="Pièces à conviction"
              >

              <div class="lpm-result-secondary-products">
                ${influenceProducts.map((product, productIndex) => `
                  <div class="lpm-result-secondary-product lpm-result-secondary-product-${productIndex + 1}">
                    ${product.image ? `<img src="${product.image}" alt="${product.title || ''}">` : ''}
                  </div>
                `).join('')}
              </div>

              ${influenceProducts.map((product, productIndex) => `
                <button
                  type="button"
                  class="lpm-result-secondary-hotspot lpm-result-secondary-hotspot-${productIndex + 1}"
                  data-influence-id="${id}"
                  data-product-index="${productIndex}"
                  aria-label="Consulter ${product.title || 'ce produit'}"
                ></button>
              `).join('')}

            </div>

          </article>
        `;
      }).join('');

      secondaryContainer.onclick = (event) => {
        const card = event.target.closest('.lpm-result-secondary-hotspot');
        if (!card) return;

        const archetypeId = card.dataset.influenceId;
        const index = Number(card.dataset.productIndex);
        const products = getResultProducts(archetypeId).slice(0, 3);

        openProductModal(products[index], index, archetypeId);
      };
    }

    if (emailCard) {
      const emailImage = {
        desktop: window.LPM_RESULT_EMAIL_IMAGE || 'https://cdn.shopify.com/s/files/1/0931/3003/1484/files/bloc-email-resultat-v3.webp?v=1781703477',
        mobile: ''
      };

      emailCard.className = 'lpm-result-email-card lpm-result-email-card--archive';

      emailCard.innerHTML = `
        <div class="lpm-result-archives-card">

          ${
            emailImage.desktop || emailImage.mobile
              ? `
                <picture>
                  ${
                    emailImage.mobile
                      ? `<source media="(max-width: 768px)" srcset="${emailImage.mobile}">`
                      : ''
                  }

                  ${
  emailImage.desktop
    ? `<img
        src="${emailImage.desktop}"
        alt="Archives confidentielles du Bureau des Affaires Maroo"
      >`
    : ''
}
                </picture>
              `
              : ''
          }

          <input
            type="email"
            class="lpm-result-archives-input"
            data-result-email-input
            placeholder="Email"
            aria-label="Adresse email"
            autocomplete="email"
          >

          <button
            type="button"
            class="lpm-result-archives-button"
            data-action="send-result-email"
            aria-label="Transmettre le dossier"
          ></button>

          <p
            class="lpm-result-archives-message"
            data-result-email-message
            aria-live="polite"
          ></p>

        </div>
      `;

      bindResultEmailForm({
        emailCard,
        winnerId,
        secondaries
      });
    }

    if (exploreContainer) {
      renderResultExplore({
        container: exploreContainer,
        winnerId,
        secondaries
      });
    }

    localStorage.setItem('lpm_maroo_quiz_result', JSON.stringify({
      universe: 'adult',
      result: winnerId,
      secondary: secondaries,
      answers
    }));

    showScreen('result');
  }

  function goBack() {
    if (currentQuestion <= 0) {
      showScreen('intro-adult');
      return;
    }

    currentQuestion -= 1;

    if (currentQuestion < 5) shownInterludes.first = false;
    if (currentQuestion < 11) shownInterludes.second = false;

    renderQuestion();
  }

  function prepareDebugAnswers(length) {
    answers = Array.from({ length }, (_, index) => {
      const question = quiz.questions[index];
      return question && question.answers && question.answers.length ? 0 : null;
    });
  }
function renderIntroAdult() {
  if (!introImage || !quiz?.intro) return;

  const isMobile = window.matchMedia('(max-width:768px)').matches;

  const image = isMobile && quiz.intro.mobile
    ? quiz.intro.mobile
    : quiz.intro.desktop;

  if (!image) {
    console.warn('LPM Quiz adulte : image intro introuvable.');
    return;
  }

  introImage.innerHTML = `
    <picture>
      <img
        src="${image}"
        class="lpm-maroo-intro-image"
        alt="Bureau des Affaires Maroo"
        loading="eager">
    </picture>
  `;
}
  function runDebugMode() {
    if (!debugScreen) return false;

    resetQuiz();

    const forcedInterludeMatch = debugScreen.match(
      /^interlude-(1|2)-(defricheuse|collectionneuse|devoreuse|irrecuperable|heritiere)$/
    );

    if (forcedInterludeMatch) {
      const interludeNumber = forcedInterludeMatch[1];
      const archetype = forcedInterludeMatch[2];

      renderForcedInterlude(interludeNumber, archetype);
      return true;
    }

    if (debugScreen === 'intro-adult') {
  renderIntroAdult();
  showScreen('intro-adult');
  return true;
}

    const questionMatch = debugScreen.match(/^question-(\d+)$/);

    if (questionMatch) {
      const requestedQuestion = Number(questionMatch[1]);
      const maxQuestion = quiz.questions.length;

      currentQuestion = Math.min(Math.max(requestedQuestion, 1), maxQuestion) - 1;
      prepareDebugAnswers(currentQuestion);

      renderQuestion();
      return true;
    }

    if (debugScreen === 'question') {
      currentQuestion = 0;
      renderQuestion();
      return true;
    }

    if (debugScreen === 'interlude-1') {
      prepareDebugAnswers(5);
      currentQuestion = 5;
      shownInterludes.first = true;
      renderInterlude('first');
      return true;
    }

    if (debugScreen === 'interlude-2') {
      prepareDebugAnswers(11);
      currentQuestion = 11;
      shownInterludes.first = true;
      shownInterludes.second = true;
      renderInterlude('second');
      return true;
    }

    if (debugScreen === 'interlude') {
      prepareDebugAnswers(5);
      currentQuestion = 5;
      shownInterludes.first = true;
      renderInterlude('first');
      return true;
    }

    if (debugScreen === 'analysis') {
      prepareDebugAnswers(quiz.questions.length);
      currentQuestion = quiz.questions.length;
      renderAnalysis();
      return true;
    }

    if (debugScreen === 'result') {
      prepareDebugAnswers(quiz.questions.length);
      currentQuestion = quiz.questions.length;
      renderResult();
      return true;
    }

    if (debugScreen === 'examiner') {
      prepareDebugAnswers(quiz.questions.length);
      currentQuestion = quiz.questions.length;
      renderResult();
      return true;
    }

    console.warn(`LPM Quiz adulte : debug inconnu → ${debugScreen}`);
    showScreen('intro-adult');
    return true;
  }

  if (runDebugMode()) return;

  root.querySelectorAll('[data-action="start"]').forEach(button => {
    button.addEventListener('click', () => {
      resetQuiz();
      renderQuestion();
    });
  });

  root.querySelector('[data-action="continue"]')?.addEventListener('click', () => {
    renderQuestion();
  });

  root.querySelector('[data-action="back"]')?.addEventListener('click', () => {
  goBack();
});

renderIntroAdult();
showScreen('intro-adult');
});
